import "bootstrap/dist/css/bootstrap.min.css"
import "./Styles/dark-bootstrap.scss"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { ConfigProvider, theme as antdThemeAlg } from "antd"
import LoginPage from "./Screens/Login/LoginPage"
import InnerRoutes from "./Routes/InnerRoutes"
import ProtectedRoute from "./Routes/ProtectedRoute"
import PublicRoute from "./Routes/PublicRoute"
import { NotificationProvider } from "./components/Notification/Notification"
import { HeaderProvider } from "./Utils/HeaderContext"
import { UiPrefsProvider } from "./Utils/UiPrefsContext"
import TwoFactorAuth from "./Screens/TwoFactorAuth/TwoFactorAuth"
import TwoFactorAuthSetup from "./Screens/TwoFactorAuth/TwoFactorAuthSetup"
import ForgotPassword from "./Screens/Login/ForgotPassword"
import ResetPassword from "./Screens/Login/ResetPassword"
import EnrollDevice from "./Screens/Enroll/EnrollDevice"
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary"

const isAuthenticated = () => {
  const user = JSON.parse(localStorage.getItem("user"))
  return user?.success && user?.data?.user?._id
}

const antdTheme = {
  algorithm: antdThemeAlg.darkAlgorithm,
  token: {
    colorPrimary: "#3b82f6",
    colorInfo: "#3b82f6",
    colorSuccess: "#22c55e",
    colorWarning: "#f59e0b",
    colorError: "#f87171",
    colorText: "#f8fafc",
    colorTextSecondary: "#94a3b8",
    colorTextTertiary: "#64748b",
    colorBorder: "rgba(148, 163, 184, 0.14)",
    colorBorderSecondary: "rgba(148, 163, 184, 0.1)",
    colorBgLayout: "#0d0d0d",
    colorBgContainer: "#1a1a1a",
    colorBgElevated: "#222222",
    colorBgSpotlight: "#222222",
    borderRadius: 12,
    fontFamily: '"Plus Jakarta Sans", Inter, "Segoe UI", sans-serif',
    controlHeight: 40,
    fontSize: 14,
  },
  components: {
    Button: {
      borderRadius: 10,
      fontWeight: 600,
      controlHeight: 40,
      primaryShadow: "0 8px 24px rgba(59, 130, 246, 0.32)",
    },
    Card: {
      borderRadiusLG: 14,
      headerFontSize: 15,
      headerHeight: 52,
      colorBgContainer: "#1a1a1a",
    },
    Input: {
      borderRadius: 10,
      colorBgContainer: "rgba(18, 18, 18, 0.9)",
      activeBorderColor: "#3b82f6",
    },
    Select: {
      borderRadius: 10,
      colorBgContainer: "rgba(18, 18, 18, 0.9)",
    },
    Table: {
      headerBg: "#141414",
      headerColor: "#94a3b8",
      rowHoverBg: "rgba(59, 130, 246, 0.08)",
      headerSplitColor: "rgba(148, 163, 184, 0.08)",
      borderColor: "rgba(148, 163, 184, 0.1)",
      colorBgContainer: "#1a1a1a",
      cellFontSize: 13,
    },
    Menu: {
      darkItemBg: "transparent",
      darkSubMenuItemBg: "transparent",
      darkItemSelectedBg: "rgba(59, 130, 246, 0.22)",
      darkItemHoverBg: "rgba(255, 255, 255, 0.06)",
    },
    Modal: {
      borderRadiusLG: 16,
      contentBg: "#222222",
      headerBg: "#222222",
    },
    Tag: {
      borderRadiusSM: 999,
    },
    Layout: {
      headerBg: "#121212",
      siderBg: "#0a0e17",
      bodyBg: "#0d0d0d",
      headerHeight: 64,
      headerPadding: "0 20px",
    },
  },
}

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <div className="dashboard-container">
        <HeaderProvider>
          <UiPrefsProvider>
          <NotificationProvider>
            <BrowserRouter>
              <Routes>
                <Route
                  path="/login"
                  element={
                    <PublicRoute isAuthenticated={isAuthenticated}>
                      <LoginPage />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/twoFactorAuth"
                  element={
                    <PublicRoute isAuthenticated={isAuthenticated}>
                      <TwoFactorAuth />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/twoFactorAuthSetup"
                  element={
                    <PublicRoute isAuthenticated={isAuthenticated}>
                      <TwoFactorAuthSetup />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/forgot-password"
                  element={
                    <PublicRoute isAuthenticated={isAuthenticated}>
                      <ForgotPassword />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/reset-password"
                  element={
                    <PublicRoute isAuthenticated={isAuthenticated}>
                      <ResetPassword />
                    </PublicRoute>
                  }
                />
                <Route path="/enroll" element={<EnrollDevice />} />
                <Route
                  path="/*"
                  element={
                    <ProtectedRoute isAuthenticated={isAuthenticated}>
                      <ErrorBoundary>
                        <InnerRoutes isAuthenticated={isAuthenticated} />
                      </ErrorBoundary>
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </BrowserRouter>
          </NotificationProvider>
          </UiPrefsProvider>
        </HeaderProvider>
      </div>
    </ConfigProvider>
  )
}

export default App
